import { render, staticRenderFns } from "./Servers.vue?vue&type=template&id=6ee45b04&scoped=true&v-if=user&"
import script from "./Servers.vue?vue&type=script&lang=js&"
export * from "./Servers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee45b04",
  null
  
)

export default component.exports